import { createFileRoute } from "@tanstack/react-router";
import { getSalesReport } from "@/lib/admin/analytics/reports.functions";
import { Card, DailyBars, DataTable, Kpi, KpiGrid, ReportPage, fmt, inr, istTime, useReport } from "@/components/admin/analytics/ReportKit";

export const Route = createFileRoute("/admin/analytics_/sales")({
  head: () => ({ meta: [{ title: "Sales Analytics — CB16 Admin" }, { name: "robots", content: "noindex" }] }),
  component: SalesAnalyticsPage,
});

function SalesAnalyticsPage() {
  const report = useReport("sales", getSalesReport);
  return (
    <ReportPage eyebrow="Analytics" title="Sales Analytics" description="Completed, paid Live orders only." report={report}>
      {(d, r) => {
        const file = `sales-${r.range.days[0]}_${r.range.days[r.range.days.length - 1]}`;
        const k = d.kpis;
        return (
          <>
            <KpiGrid>
              <Kpi label="Net revenue" value={inr(k.netRevenue)} sub="Amount customers paid" />
              <Kpi label="Gross sales" value={inr(k.grossSales)} sub="Before discounts and delivery" />
              <Kpi label="Completed orders" value={fmt(k.completedOrders)} />
              <Kpi label="Average order value" value={inr(k.averageOrderValue)} />
              <Kpi label="Discounts" value={inr(k.discounts)} />
              <Kpi label="Delivery charges" value={inr(k.deliveryCharges)} />
              <Kpi label="GST collected" value={inr(k.taxCollected)} sub="Included in prices" />
              <Kpi label="Refunds" value={inr(k.refunds)} sub={`${k.refundCount} order(s)`} />
              <Kpi label="Payment success" value={`${k.paymentSuccessPct}%`} sub={`${k.paymentAttempts} Live attempt(s)`} />
            </KpiGrid>
            <section className="grid gap-4 lg:grid-cols-2">
              <Card title="Revenue trend" rows={d.trend} file={`${file}-revenue`}><DailyBars points={d.trend} format={inr} /></Card>
              <Card title="Orders per day" rows={d.ordersTrend} file={`${file}-orders-per-day`}><DailyBars points={d.ordersTrend} /></Card>
            </section>
            <section className="grid gap-4 lg:grid-cols-2">
              <Card title="Top products" rows={d.topProducts} file={`${file}-products`}>
                <DataTable head={["Product", "Units", "Revenue"]} rows={d.topProducts.map((p) => [p.product, fmt(p.units), inr(p.revenue)])} />
              </Card>
              <Card title="Payment attempts (Live)" rows={d.attempts} file={`${file}-payments`}>
                <DataTable head={["Status", "Attempts"]} rows={d.attempts.map((a) => [a.status, fmt(a.count)])} />
              </Card>
            </section>
            <Card title="Orders in this period" rows={d.orders} file={`${file}-orders`}>
              <DataTable
                head={["Order", "Placed (IST)", "Status", "Payment", "Counted as sale", "Total"]}
                rows={d.orders.map((o) => [o.order, istTime(o.placed), o.status, o.payment, o.counted, inr(o.total)])}
              />
            </Card>
            <p className="text-[11px] text-black/40">
              {d.excluded} test, demo or pre-Live order(s) in this period were left out. Cancelled, refunded and failed orders never count as sales.
            </p>
          </>
        );
      }}
    </ReportPage>
  );
}
